import { z } from 'zod';

export const IMediaReferenceSchema = z.object({
  id: z.string(),
  uri: z
    .object({
      original: z.string(),
    })
    .catchall(z.string()),
});

export enum MediaField {
  ALT_TEXT = 'altText',
}

export enum DocumentCategory {
  CERTIFICATE_OF_INSURANCE = 'certificate_of_insurance',
  BRAND_HOST_AGREEMENT = 'brand_host_agreement',
  OTHER = 'other',
}

export const DocumentSchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  uri: z.string(),
  brandId: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  uploadedById: z.string().uuid(),
  category: z.nativeEnum(DocumentCategory),
  metadata: z
    .record(z.unknown())
    .nullable()
    .optional()
    .transform((metadata) => metadata ?? null),
  uploadedAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const GetDocumentsQuerySchema = z.object({
  userId: z.string().uuid().optional(),
});

export const GetDocumentSignedUrlResponseSchema = z.object({
  name: z.string(),
  url: z.string(),
});

export const UploadDocumentRequestSchema = z.object({
  userId: z.string().uuid(),
  category: z.nativeEnum(DocumentCategory),
  label: z.string().nullable().optional(),
});

export const UpdateDocumentRequestSchema = z.object({
  label: z.string(),
});

export const GetDocumentsResponseSchema = z.array(DocumentSchema);

export type UploadDocumentResponse = z.output<typeof DocumentSchema>;

export type GetDocumentsResponse = z.output<typeof GetDocumentsResponseSchema>;

export type GetDocumentsQuery = z.output<typeof GetDocumentsQuerySchema>;

export type UploadDocumentRequest = z.output<typeof UploadDocumentRequestSchema>;

export type UpdateDocumentRequest = z.output<typeof UpdateDocumentRequestSchema>;

export type UpdateDocumentResponse = z.output<typeof DocumentSchema>;

export enum ListingPictureKind {
  GALLERY = 'gallery',
  COVER = 'cover',
  MAP = 'map',
  DESCRIPTION = 'description',
}
